'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _class;
var _map = require('../map');
var _map2 = _interopRequireDefault(_map);
var _utils = require('../utils');
var utils = _interopRequireWildcard(_utils);
var _ramda = require('ramda');
var _selectors = require('./selectors');
var _selectors2 = _interopRequireDefault(_selectors);
var _accessors = require('./accessors');
var _accessors2 = _interopRequireDefault(_accessors);
var _computors = require('./computors');
var _computors2 = _interopRequireDefault(_computors);
var _eauors = require('./eauors');
var _eauors2 = _interopRequireDefault(_eauors);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ChoroplethChart = (0, _selectors2.default)(_class = (0, _accessors2.default)(_class = (0, _computors2.default)(_class = (0, _eauors2.default)(_class = function (_MapChart) {
  (0, _inherits3.default)(ChoroplethChart, _MapChart);
  function ChoroplethChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var getInitialOptions = arguments[3];
    (0, _classCallCheck3.default)(this, ChoroplethChart);
    var _this = (0, _possibleConstructorReturn3.default)(this, (ChoroplethChart.__proto__ || (0, _getPrototypeOf2.default)(ChoroplethChart)).call(this, el, options, data));
    _update(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      computors: _this.constructor.computors,
      eauors: _this.constructor.eauors
    }, _this.base, _this.map);
    return _this;
  }
  (0, _createClass3.default)(ChoroplethChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var getInitialOptions = arguments[3];
      (0, _get3.default)(ChoroplethChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ChoroplethChart.prototype), 'update', this).call(this, el, options, data, getInitialOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      }, this.base, this.map);
    }
  }]);
  return ChoroplethChart;
}(_map2.default)) || _class) || _class) || _class) || _class;
exports.default = ChoroplethChart;
function _update(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var data = arguments[2];
  var ors = arguments[3];
  var base = arguments[4];
  var map = arguments[5];
  if (process.env.NODE_ENV !== 'production') {
    console.time(utils.prefix + ' ChoroplethChart#_update');
  }
  var colorScale = ors.computors.colorScale(options, data);
  var relevantsAreas = d3.select(el).selectAll(utils.selector(ors.selectors.land)).filter(function (d) {
    return (0, _ramda.pathOr)(null, ['properties', 'value'], d);
  });
  relevantsAreas.call(ors.eauors.relevantAreasUpdate, ors.accessors, options.serie, colorScale, base);
  if (ors.accessors.labelDisplay !== 'none') {
    var labels = d3.select(el).select(utils.selector(ors.selectors.map)).selectAll(utils.selector(ors.selectors.area)).selectAll(utils.selector(ors.selectors.label)).data(function (data) {
      return [data];
    });
    labels.enter().call(ors.eauors.labelEnter, ors.selectors);
    labels.call(ors.eauors.labelUpdate, options, ors.accessors, map.projection);
    labels.exit().remove();
  }
  if (process.env.NODE_ENV !== 'production') {
    console.timeEnd(utils.prefix + ' ChoroplethChart#_update');
  }
}